import { request } from '@/utils/request'
const RealTimeService = {
  state: {},

  mutations: {},

  actions: {
    // 获取设备树
    getEquipTree({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetProjectTree', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetJianCeXiangList_ZhiXin_Temp({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetJianCeXiangList_ZhiXin_Temp', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询 : 可被监测的 设备ID 列表
    GetIsCalTreeList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetIsCalTreeList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取结构图--完成
    GetStructureCommon({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetStructureCommon', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取设备某属性的对比曲线
    getComparativeCurveData({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetQvXian_By_EquipmentIDstr_DoubleLine', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取配电室一次图数据
    getDiagramData({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetYiCiTue', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取环境量实时数据
    GetFuZhuJianKong({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetFuZhuJianKong', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 变压器负载
    GetDangQianFuHe({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v1/GetDangQianFuHe', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 项目概况
    GetTongJiAndProjectInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v1/GetTongJiAndProjectInfo', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 变压器三项不平衡
    GetSanXianBuPingHeng({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v1/GetSanXianBuPingHeng', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 变压器用电统计
    GetYongDianLiangForBYQ({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/tongji/v1/GetYongDianLiangForBYQ', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设备概况
    GetSheBeiGongKuangList_New({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetSheBeiGongKuangList_New', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetModeList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetModeList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设备工况图标数据
    GetSheBeiGongKuangSummary({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v1/GetSheBeiGongKuangSummary', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设备工况图设备弹窗
    GetCommunicationEquipmentsSheBeiGongKuangList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetCommunicationEquipmentsSheBeiGongKuangList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设备工况图设备弹窗
    GetCommunicationTerminalsSheBeiGongKuangList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetCommunicationTerminalsSheBeiGongKuangList', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 遥控设备（一次图）
    ControlMessage_Switch({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/helens/v1/ControlMessage_Switch', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default RealTimeService
